import { Box, useMobile } from '@octano/global-ui';
import { useTexts } from '../hooks/useTexts';
import { format } from 'rut.js';

type Props = {
  teacherName: string;
  teacherIdentification: string;
};

export function TeacherInfo({ teacherName, teacherIdentification }: Props) {
  const isMobile = useMobile();
  const texts = useTexts();
  return (
    <Box
      color="primary"
      variant="outlined"
      style={{ borderRadius: 4 }}
      className={`py-2 px-3 ${isMobile && 'mt-4 w-100'}`}
      body={
        <div className="d-flex justify-content-between">
          <Box
            color="primary"
            variant="outlined"
            className="p-0 border-0 w-50 text-uppercase"
            title={texts.teacherInfo.teacherLabel}
            style={{ minWidth: isMobile ? 0 : 140 }}
            body={<p className="fs-14 mb-0 text-capitalize">{teacherName}</p>}
          />

          <Box
            color="primary"
            variant="outlined"
            className="p-0 border-0 w-50 text-uppercase"
            title={texts.teacherInfo.idLabel}
            style={{ minWidth: isMobile ? 0 : 140 }}
            body={format(teacherIdentification)}
          />
        </div>
      }
    />
  );
}
